import ClientService from '../../services/client-service';
import getSettingsDataQuery from '../../graphql/query/get-settings-data.graphql';
import getUserApiKeyQuery from '../../graphql/query/get-user-api-key.graphql';
import resetUserSettingsMutation from '../../graphql/mutation/reset-user-settings.graphql';
import exportUserSettingsMutation from '../../graphql/mutation/export-user-settings.graphql';
import importUserSettingsMutation from '../../graphql/mutation/import-user-settings.graphql';

export default class SettingsApi {
  public static getSettingsData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlQueryRequest(getSettingsDataQuery, payload);
  }

  public static getUserApiKey(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlQueryRequest(getUserApiKeyQuery, payload);
  }

  public static resetUserSettings(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(resetUserSettingsMutation, payload);
  }

  public static exportUserSettings(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(exportUserSettingsMutation, payload);
  }

  public static importUserSettings(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(importUserSettingsMutation, payload);
  }
}
